import DataAlertImport from "./data-alert-import" ;

export default DataAlertImport 